import React from 'react';
import { Text, TextProps } from '@mantine/core';
import { P1Medium as P1MediumStyle } from 'theme/typography';

interface P1MediumProps extends TextProps {
  customStyle?: React.CSSProperties;
  children: React.ReactNode; // Explicitly define the children prop
}

/**
 * Applies the P1Medium typography style.
 */
const P1Medium: React.FC<P1MediumProps> = ({ children, customStyle, ...restProps }) => {
  return (
    <Text {...restProps} style={{ ...P1MediumStyle, ...customStyle }}>
      {children}
    </Text>
  );
};

export default P1Medium;
